<template>
  <div>
    <Nav v-bind:organization="organization" />
    <div class="app">
      <Sidebar />
      <div id="organization_main_view">
          <div class="floating-container">
            <div class="floating-header">
              <h1>Site Settings</h1>
              <router-link to="../"><button class="small">← Go Back</button></router-link>
            </div>
            <SiteSettingsForm v-bind:site="site" />
          </div>
          <div class="floating-container">
            <h1>Advanced Settings</h1>
            <SiteAdvancedSettingsForm v-bind:site="site" />
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import "../css/main.css";
import "../css/components.css";

import utils from "../js/utils.js";

import Table from "./generics/Table";
import Sidebar from "./generics/Sidebar";
import Nav from "./generics/Nav";
import SiteSettingsForm from "./special/SiteSettingsForm";
import SiteAdvancedSettingsForm from "./special/SiteAdvancedSettingsForm";

import store from '@/js/store';

export default {
  name: 'OrganizationMainView',
  data () {
    const data = {
      organization: {},
      site: {},
    };

    (async () => {
      const { public_key } = this.$route.params;
      const { organization, sites } = await utils.generalInformation({ site_public_key: public_key });

      data.organization = organization;
      data.site = sites.find(o => o.public_key === public_key);
      if (!data.site.article_generation) data.site.article_generation = {};
      if (!data.site.metadata) data.site.metadata = {};
    })();

    return data;
  },
  components: {
    SiteSettingsForm,
    SiteAdvancedSettingsForm,
    Sidebar,
    Nav,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.app {
  text-align: center;
  margin-top: 20px;
}

#organization_main_view {
  width: 1252px;
  display: inline-block;
  text-align: left;
}

.floating-header {
  width: 613px;
}
</style>



// WEBPACK FOOTER //
// src/components/OrganizationSiteSettings.vue